// ConfirmModal.jsx — shared destructive-action confirm modal for AI Dialer
// surfaces (campaigns delete, screeners delete, etc.).
//
// Closes on Escape + backdrop click; focuses the cancel button on open.
// Extracted from AIDialer.jsx so the screeners list can reuse the exact
// same look + a11y wiring.

import React, { useEffect, useRef } from 'react';
import { Loader2 } from 'lucide-react';

export default function ConfirmModal({
  title,
  body,
  confirmLabel = 'Confirm',
  danger = false,
  busy = false,
  onConfirm,
  onCancel,
}) {
  const cancelRef = useRef(null);
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onCancel?.(); };
    document.addEventListener('keydown', onKey);
    cancelRef.current?.focus();
    return () => document.removeEventListener('keydown', onKey);
  }, [onCancel]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="ai-dialer-confirm-title"
      className="fixed inset-0 z-60 flex items-center justify-center bg-black/60 backdrop-blur-xs p-4"
      onClick={onCancel}
    >
      <div onClick={(e) => e.stopPropagation()} className="panel p-5 max-w-sm w-full space-y-4">
        <div id="ai-dialer-confirm-title" className="font-display font-bold text-lg text-white">{title}</div>
        <div className="text-sm text-white/70">{body}</div>
        <div className="flex justify-end gap-2 pt-1">
          <button ref={cancelRef} onClick={onCancel} disabled={busy} className="btn-ghost">Cancel</button>
          <button
            onClick={onConfirm}
            disabled={busy}
            className={`px-3 py-2 rounded-md text-sm font-medium text-white ${danger ? 'bg-rose-500/80 hover:bg-rose-500' : 'bg-civix-purple/80 hover:bg-civix-purple'}`}
          >
            {busy ? <Loader2 className="w-4 h-4 animate-spin inline-block" /> : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
